import { formatNumber } from "../../shared/utility";

const GenericTable = ({
  columns,
  rows,
  disabledInputField = false,
  order,
  tableDisabled = false,
  currencyCode,
}) => {
  return (
    <div className="card mb-4">
      <div className="card-body p-0">
        <table className="table custom-row-padding">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index} style={{ width: col.width || "auto" }}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                className={`align-middle  ${
                  row.refundableQuantity === 0 || tableDisabled
                    ? "text-muted table-disabled-row"
                    : ""
                }`}
                key={row.id}
              >
                {columns.map((col, colIndex) => {
                  const value = row[col.accessor];

                  if (col.render) {
                    return (
                      <td key={colIndex}>
                        {col.render(row, disabledInputField)}
                      </td>
                    );
                  }

                  return (
                    <td className="text-content" key={colIndex}>
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr
              className={`align-middle no-stripe-row ${
                tableDisabled ? "text-muted table-disabled-row" : ""
              } `}
            >
              <td>
                <div>
                  <div className="fw-normal text-content">Shipping cost</div>
                  <div className="text-content" style={{ fontSize: "0.75rem" }}>
                    Usman Rasheed, 47 Racine Road Unit 2, Toronto, Ontario,
                    M9W6B2, Canada
                  </div>
                </div>
              </td>

              {/* Render empty cells or dashes for other columns except last two */}
              {columns.slice(1, columns.length - 3).map((_, idx) => (
                <td key={idx}>—</td>
              ))}

              {/* Last two columns with values */}
              <td className="text-content">
                {currencyCode}
                {formatNumber(order?.base_shipping_cost)}
              </td>
              <td>—</td>
              <td className="text-content">
                {disabledInputField ? (
                  <div className="input-group input-group-sm">
                    <span className="input-group-text">{currencyCode}</span>
                    <input
                      type="number"
                      className={`form-control`}
                      id="refund-amount"
                      disabled={disabledInputField}
                      value={parseFloat(order?.base_shipping_cost)}
                    />
                  </div>
                ) : (
                  `${currencyCode}${formatNumber(order?.base_shipping_cost)}`
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GenericTable;
